import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

class Menu extends Component {
	render() {
		return (
			<nav className="navbar navbar-expand-sm navbar-dark bg-dark" style={{ marginBottom: "1em" }}>
				<a className="navbar-brand">
					<img src={require('../../img/carteira.svg')} width="30" height="30" alt="" />
				</a>
				<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent">
					<span className="navbar-toggler-icon" />
				</button>
				<div className="collapse navbar-collapse" id="navbarSupportedContent">
					{this.props.nomeUsuario && (
						<ul className="navbar-nav">
							<li className="nav-item">
								<NavLink to="/" className="nav-link" activeClassName="active" exact >
									<i className="fas fa-home" style={{ cursor: "pointer" }} />
								</NavLink>
							</li>
							<li className="nav-item">
								<NavLink to="/movimentacao" className="nav-link" activeClassName="active" >
									<i className="fas fa-hand-holding-usd" style={{ cursor: "pointer" }} />
								</NavLink>
							</li>
							<li className="nav-item">
								<NavLink to="/transferencia" className="nav-link" activeClassName="active" >
									<i className="fas fa-exchange-alt" style={{ cursor: "pointer" }} />
								</NavLink>
							</li>
							<li className="nav-item">
								<NavLink to="/extrato" className="nav-link" activeClassName="active" >
									<i className="fas fa-history" style={{ cursor: "pointer" }} />
								</NavLink>
							</li>
							<li className="nav-item">
								<NavLink to="/tarefa" className="nav-link" activeClassName="active" >
									<i className="fas fa-tasks" style={{ cursor: "pointer" }} />
								</NavLink>
							</li>
							<li className="nav-item dropdown navbar-dark bg-dark">
								<a className="nav-link dropdown-toggle" data-toggle="dropdown">
									<i className="fas fa-chart-pie" style={{ cursor: "pointer" }} />
								</a>
								<div className="dropdown-menu bg-dark">
									<NavLink to="/sumario" className="nav-link dropdown-item" activeClassName="active" >
										Sumário
								</NavLink>
									<NavLink to="/relCCustos" className="nav-link dropdown-item" activeClassName="active" >
										Por Centro de Custos
								</NavLink>
									<NavLink to="/relProventos" className="nav-link dropdown-item">
										Proventos
								</NavLink>
									<NavLink to="/relProventosAtivos" className="nav-link dropdown-item">
										Proventos Por Ativos
								</NavLink>
									<NavLink to="/relCarteira" className="nav-link dropdown-item">
										Carteira
								</NavLink>
								</div>
							</li>
							<li className="nav-item dropdown navbar-dark bg-dark">
								<a className="nav-link dropdown-toggle" data-toggle="dropdown">
									<i className="fas fa-id-card-alt" style={{ cursor: "pointer" }} />
								</a>
								<div className="dropdown-menu bg-dark">
									<NavLink to="/contas" className="nav-link dropdown-item">
										Contas
								</NavLink>
									<NavLink to="/ccustos" className="nav-link dropdown-item">
										Centro de Custos
								</NavLink>
								</div>
							</li>
							<li className="nav-item dropdown navbar-dark bg-dark">
								<a className="nav-link dropdown-toggle" data-toggle="dropdown">
									<i className="fas fa-chart-line" style={{ cursor: "pointer" }} />
								</a>
								<div className="dropdown-menu bg-dark">
									<NavLink to="/carteira" className="nav-link dropdown-item">
										Carteira
								</NavLink>
									<NavLink to="/csv" className="nav-link dropdown-item">
										CSV
								</NavLink>
									<NavLink to="/posicao" className="nav-link dropdown-item">
										Posição Consolidada
								</NavLink>
									<NavLink to="/proventosAnual" className="nav-link dropdown-item">
										Proventos Anuais
								</NavLink>
									<NavLink to="/proventosQuick" className="nav-link dropdown-item">
										Proventos Quick Add
								</NavLink>
									<NavLink to="/proventosUltraQuick" className="nav-link dropdown-item">
										Proventos Ultra Quick Add
								</NavLink>
									<NavLink to="/composicao" className="nav-link dropdown-item">
										Composição da Carteira
								</NavLink>
									<NavLink to="/pesos" className="nav-link dropdown-item">
										Pesos dos Ativos
								</NavLink>
									<NavLink to="/movAtivo" className="nav-link dropdown-item">
										Primeira compra do ativo
								</NavLink>
									<NavLink to="/rfixas" className="nav-link dropdown-item">
										Primeira compra de RF
								</NavLink>
									<NavLink to="/ativos" className="nav-link dropdown-item">
										Ativos
								</NavLink>
								</div>
							</li>
						</ul>)}
					{!this.props.nomeUsuario && (
						<ul className="navbar-nav">
							<li className="nav-item">
								<NavLink to="/login" className="nav-link" activeClassName="active" >
									Login
								</NavLink>
							</li>
							<li className="nav-item">
								<NavLink to="/registro" className="nav-link" activeClassName="active" >
									Registrar
								</NavLink>
							</li>
						</ul>
					)}
				</div>
			</nav>
		);
	}
}

Menu.propTypes = {
	nomeUsuario: PropTypes.string.isRequired
};

function mapStateToProps({ nomeUsuario, router }) {
	return {
		nomeUsuario,
		router
	};
}

export default connect(mapStateToProps)(Menu);



// WEBPACK FOOTER //
// ./src/components/common/Menu.js